import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { MaybeDate } from '../models/date-helpers.models';
import { Maybe } from 'purify-ts';
import { getInvertedString } from '../utils/typeconversions';
import { Format } from '../utils/format';

/**
 * util basicamente para passar model do tipo date para [value] de input html
 */
@Pipe({
  name: 'dateToInvertedString',
  standalone: true,
})
export class DateToInvertedString implements PipeTransform {

  transform(value: Date | null | undefined){
    // return Format.dateToInvertedStringFormat(value!)
    const date =  getInvertedString(value);
    return date.caseOf({
      Just: val => val,
      Nothing : () => ''
    })
  }

}
